/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getCustomersRequest: ['page', 'page_size', 'sort', 'search'],
  getCustomersSuccess: ['list'],

  getCustomersFetchingReset: null,
  getCustomersReset: null,

  getCustomerIdRequest: ['id'],
  getCustomerIdSuccess: ['focusRow'],
  getCustomerIdReset: null,

  updateCustomerIdRequest: ['id', 'data'],
  updateCustomerIdSuccess: ['updateCustomerResult'],

  deleteCustomerRequest: ['id'],
  deleteCustomerSuccess: ['deleteCustomerResult'],
  deleteCustomerReset: null,
})

export const CustomersReduxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  page: 1,
  page_size: 15,

  deleteCustomerResult: null,
  updateCustomerResult: null,

  customerFetching: false,

  focusRow: null,
})

/* ------------- Selectors ------------- */

export const CustomersSelectors = {
  customersList: state => state.customers.list,
  customerInfo: state => state.customers.focusRow,
}

/* ------------- Reducers ------------- */
export const getCustomersRequest = (state, {page, page_size, sort, search}) => {
  const newState = {
    fetching: true,
  }
  page && (newState.page = page)
  page_size && (newState.page_size = page_size)
  return state.merge(newState)
}
export const getCustomersSuccess = (state, {list}) => {
  let newResult = list?.results?.map(customer => ({
    ...customer,
    subscription: customer.subscription ? customer.subscription : {id: 1, name: 'Free', price: 0, subscribed_monthly: null},
  }))
  let newList = {...list, ...newResult}

  return state.merge({fetching: false, list: newList})
}

export const getCustomersFetchingReset = state => {
  return state.merge({fetching: false, customerFetching: false})
}
export const getCustomersReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    page: 1,
    page_size: 15,

    deleteCustomerResult: null,
    updateCustomerResult: null,

    customerFetching: false,

    focusRow: null,
  })
}

export const getCustomerIdRequest = (state, {id}) => {
  return state.merge({customerFetching: true})
}
export const getCustomerIdSuccess = (state, {focusRow}) => {
  let newData = {
    ...focusRow,
    subscription: focusRow.subscription ? focusRow.subscription : {id: 1, name: 'Free', price: 0, subscribed_monthly: false},
  }
  return state.merge({customerFetching: false, focusRow: newData})
}

export const updateCustomerIdRequest = (state, {id, data}) => {
  return state.merge({customerFetching: true})
}

export const updateCustomerIdSuccess = (state, {updateCustomerResult}) => {
  return state.merge({
    focusRow: updateCustomerResult,
    customerFetching: false,
  })
}

export const getCustomerIdReset = state => {
  return state.merge({focusRow: null})
}

export const deleteCustomerRequest = (state, {id, data}) => {
  return state.merge({customerFetching: false})
}
export const deleteCustomerSuccess = (state, {deleteCustomerResult}) => {
  return state.merge({
    customerFetching: false,
  })
}
export const deleteCustomerReset = (state, {}) => {
  return state.merge({customerFetching: false, deleteCustomerResult: null})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CUSTOMERS_REQUEST]: getCustomersRequest,
  [Types.GET_CUSTOMERS_SUCCESS]: getCustomersSuccess,

  [Types.GET_CUSTOMERS_FETCHING_RESET]: getCustomersFetchingReset,
  [Types.GET_CUSTOMERS_RESET]: getCustomersReset,

  [Types.GET_CUSTOMER_ID_REQUEST]: getCustomerIdRequest,
  [Types.GET_CUSTOMER_ID_SUCCESS]: getCustomerIdSuccess,
  [Types.GET_CUSTOMER_ID_RESET]: getCustomerIdReset,

  [Types.UPDATE_CUSTOMER_ID_REQUEST]: updateCustomerIdRequest,
  [Types.UPDATE_CUSTOMER_ID_SUCCESS]: updateCustomerIdSuccess,

  [Types.DELETE_CUSTOMER_REQUEST]: deleteCustomerRequest,
  [Types.DELETE_CUSTOMER_SUCCESS]: deleteCustomerSuccess,
  [Types.DELETE_CUSTOMER_RESET]: deleteCustomerReset,
})
